module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("J")])])]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ohnny. Johnny.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her heart whispered his name as the Jeep carried Bridget Donovan closer and closer to the man she’d never been able to forget. Tonight was the first time she’d heard his voice in nearly five years and the sound of it had shaken her, almost as much as his request.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Will you come to my home? Grandmother is sick.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tears suddenly blurred her vision and she automatically eased her foot from the gas pedal as she struggled to compose herself.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("Even though the two of them resided in the same southern area of New Mexico, their lives moved along different trails. Once they’d parted, she’d never expected to cross his path again. But she’d often dreamed, hoped and desperately prayed that might change one day. He’d contacted her tonight out of desperation and nothing else. Yet that made little difference to her. The only ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("thing that mattered was in a very few minutes she was going to see the only man she’d ever loved.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Johnny Chino didn’t know why he continued to clutch his cell phone as he stared out the window at the dark dirt road leading up to his mountainside home. He’d already forced himself to make the call. A call he’d once sworn to never make again. But for some reason he couldn’t slip the instrument back into his pocket and out of sight. Instead he gripped the phone as though he could hold on to her voice. Hold on to her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The idea was as ridiculous as the dreams and hopes he’d once had for the two of them. And now he felt like a fool for standing at the window, watching with a mixture of dread and eagerness, for the flicker of her headlights.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wasn’t coming to see him. No, those times were gone and long past, he grimly reminded himself. She’d moved on without him. Just as he’d intended.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Jeep rattled across the wooden slats of an old cattle guard and then Bridget pressed hard on the accelerator as the gravel road began a steep climb between tall pines mixed with white-trunked aspens. The autumn night was cold and clear, but the starry sky was blotted out by the thick forest covering this portion of the Mescalero Apache Indian Reservation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Years had passed since she’d traveled this particular road, but driving the unfamiliar twists and turns in the dark wasn’t nearly as unsettling as the thought of what she might find once she reached her destination.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("The Chino home sat on a hacked-out piece of mountain land that had originally been hand cleared by Johnny’s grandfather, Charlie. As her headlights swept ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("the front of the small structure, Bridget could see the modest stucco was just a shade paler than the red-brown dirt that made up a small yard. The pine tree shading the small porch had grown much taller than she remembered, but everything else looked as it had so many years ago.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she gathered up her medical bag, she heard dogs barking somewhere near the house and then a deep male voice calling to the animals. Swallowing hard, she glanced out the windshield and saw "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Johnny")]), _vm._v(" walking toward her vehicle. A red bone hound and a black collie trotted to keep up with his long, lithe stride.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bracing herself as best she could, Bridget grabbed the handle of her bag with one hand and opened the Jeep door with the other. Before she could slide to the ground, he was standing only a step away, waiting for her to make the next move. Bridget focused her gaze on his face and suddenly everything came to an abrupt stop. Her breath hung suspended, her heart halted in midbeat and all she could do was stare. And ache.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even in the semidarkness, she could see Johnny’s face was as striking as the image she’d carried around in her memory. Long, crow-black hair was pulled from his face and tied at his nape with a short piece of worn leather. Smooth bronze skin stretched across high prominent cheekbones, while a noble nose gave way to a pair of roughly hewn lips. Beneath a hooded line of black brows, his dark eyes pierced her with an unflinching gaze.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bridget realized she should speak, but the tangle of knots in her throat made it nearly impossible to swallow, much less form a word. Forcing her lips to part, she tried to utter a greeting. But after a moment even that seemed trivial and unnecessary.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Grandmother refuses to leave her bed,” he finally said. “I’m very worried.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His words snapped her from her frozen state and she made a move to step down from the Jeep. Just as quickly, Johnny’s hand came around her elbow to assist her to the rocky ground and Bridget struggled to keep from gasping out loud. Even if his touch was shooting searing rivulets of heat up her arm, she couldn’t allow herself to forget she was here as a doctor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How long has she been ill?” Bridget managed to ask.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Three days. Only tonight, she asked to see you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When Johnny had called the ranch earlier tonight, she’d wondered why he’d not contacted the Apache hospital in Mescalero for a doctor’s help rather than call upon her. The facility was far closer to the Chino home and offered free medical services to members of their tribe. Now he was making it clear that it had been Naomi’s idea to summon her, instead of his. The news hardly surprised Bridget. But she felt ridiculously disappointed anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll see what I can do,” she promised.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The walk to the house was short and no more words were exchanged as he opened the front door and allowed her to precede him into a small, comfortable living room. In one corner, the crackling flames from a fireplace emitted a dim, orange-gold cast to the room and its basic furnishings. Other than that, there were no other sources of light or sound.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bridget paused and, though she was familiar with the layout of the house from years before, she waited for his instructions.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She’s in the back bedroom. Grandfather is with her.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("Bridget followed him out of the room and into a dimly ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("lit kitchen where the scent of fried bacon still lingered in the air. To one side of the room there was an opening followed by a short hallway. At the end of it, they entered a bedroom that, compared to the rest of the house, felt unusually cool and drafty. Her gaze was immediately drawn to the single window directly across from them and was amazed to see it was raised slightly.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Turning a questioning look at Johnny, she asked, “Is there some reason for the cold air?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One corner of his mouth quirked slightly. “Grandmother believes fresh air is a cure-all.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bridget held back a frustrated sigh. Now was not the time to offend the older woman by trying to change her beliefs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, she can’t keep lying in a draft like this. Perhaps she won’t notice if you close it while I’m examining her,” Bridget suggested in a voice only for his ears.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He gave her a barely discernible nod and Bridget moved away from him and toward the double bed pushed against the far wall of the room. At the head of it, Johnny’s grandfather, Charlie Chino, was sitting in a wooden, straight-back chair. His weathered old face was full of worry, but he said nothing as Bridget approached.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Naomi was resting on her side with her eyes shut. Her long white hair was unbraided and lying loose upon a pair of frail shoulders. Five years’ time had wrinkled the woman’s face even more and Bridget made a quick mental calculation to determine that Naomi would most likely be in her early nineties now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bending over the low bed, Bridget caught the sound of her wheezy breaths. The raspy noise was not what she wanted to hear.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Placing a palm upon Naomi’s forehead, she called her name. “Can you hear me, Mrs. Chino? Naomi?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thin, crinkled eyelids fluttered, before slowly lifting to expose a pair of milky brown eyes. For long moments they stared straight at Bridget and then to her relief, she spotted a flicker of recognition in their depths.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Bridget.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The weak whisper of her name very nearly caused tears to well in Bridget’s eyes. But she did her best to blink them away and call upon her professional steadiness to get her through the moment. This woman had once meant much to her, and over the past years, Bridget had never forgotten the closeness they’d shared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, it’s me, Naomi. I’m here to help you get well. Is that okay with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Naomi’s bony hand slipped from beneath the heavy covers and reached for Bridget’s. She gave it to her willingly and was relieved to feel a bit of strength in the woman’s grasp.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. I’ll get well now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Straightening to her full height, Bridget reached for her bag and realized, with somewhat of a start, that Johnny was standing directly behind her. She’d thought he was still dealing with the window, but then he’d always had the uncanny ability to move without making a sound.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Forcing herself to look at him squarely, Bridget asked, “Has she been coughing?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A little.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Does she have any other health problems I should know about?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Grandmother is ninety-three,” he said, as if that should answer everything.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Bridget reminded herself that this man had always ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("moved at a different pace. “Does she take any medications?”")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Johnny looked at his grandfather and spoke to him in their native language. The older man simply shook his head, which prompted Johnny to translate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you. That helps,” Bridget told him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She pulled several instruments from her bag and went to work taking Naomi’s vital signs and examining her from head to toe. Along with an elevated temperature, the woman’s heartbeat was weak and rapid and her lungs rattled with the warning of impending pneumonia.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bridget’s first instinct was to demand that Naomi be taken to the hospital so that she could receive round-the-clock care and intravenous medications. But if the woman had already refused Johnny’s pleas for her to go to a medical facility, then no good would come of further prodding by Bridget. Johnny had always been the apple of Naomi’s eye. If she wouldn’t heed his pleas, then her mind was already set like cement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thankfully, Bridget had treated an illness similar to Naomi’s earlier in the day and she’d left a bottle of the antibiotics stored on dry ice in her medical bag. As she filled a syringe with the correct amount, Johnny asked, “What’s wrong with her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("While she’d been examining Naomi, Bridget had felt his presence, felt his gaze watching her every movement. To make sure she treated his grandmother gently? Or because he still ached for her, the way she’d ached for him all these years? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh, God, don’t let her think about that now,")]), _vm._v(" she prayed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She appears to have the flu. Have you or your grandfather been ill? Or been around anyone coughing or sick?”")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. But Grandmother worked at the farmers’ market last weekend—helping her friend sell squash and pumpkin. Someone there might have been sick.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bridget nodded while deciding there was no use in asking if any of them had taken a flu shot. The Chinos lived basically as they had years ago. Preventative medicine was not something they practiced.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After giving Naomi the injection of antibiotics in her hip, she tucked the covers warmly around her, then glanced at Johnny. “Does the glass of water on the nightstand belong to your grandmother? She needs to swallow a few pills.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll get fresh water,” he told her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was gone from the room less than a minute before he returned with a small glass filled with chilled water.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After thanking him, Bridget took the drink and, lifting Naomi’s head, helped her tilt the glass to her lips. If they did their job, the pills would help to reduce her fever and loosen the phlegm in her chest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That should help you feel a bit better, Naomi.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She lowered the woman’s white head back to the pillow and Naomi nodded drowsily. Bridget moved away from the bed and signaled for Johnny to join her outside the room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the hallway, he glanced solemnly back to the door of his grandparents’ bedroom, then to her. At that moment, Bridget wanted to wrap her hands around his, to comfort and assure him that he wasn’t going to lose the only mother he’d ever known. At least, not if she could help it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She needs to be in the hospital, Johnny. Will she not go to the Indian medical facility in Mescalero?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She’d rather die in her bed,” he said grimly. “She’s particular about who she lets near her.”")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bridget released a long sigh. The Apaches provided excellent health care for their people. It didn’t make sense that Naomi would refuse the services of her own tribe. But she had to remember that Naomi had never wanted to accept the more modern ways. Still, why would the old woman insist that Bridget be the one to doctor her?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, I’m thankful she trusts me enough to allow me to treat her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His dark gaze roamed her face and upswept hair and though she did her best to stem the memory of his embrace, she was suddenly reliving the sensation of his hands tangled in her copper-red curls, his lips ravishing hers. No man had ever touched her the way that he had. And she doubted any man ever would.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He asked, “Will she get well?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She blinked as Johnny’s voice shattered the erotic image in her head. “I think so. But at her age it’s easy for things to go wrong.” Even though the interior of the house was cool, Bridget’s cheeks felt flush and her upper body on the verge of sweating. Rubber seemed to have replaced the bones in her legs and she realized with a bit of shock that if she didn’t sit and pull herself together she was going to faint. “Can—we go to the kitchen to finish this discussion? I could use a cup of coffee.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wordlessly, he gestured for her to precede him down the short hallway. Pulling back her shoulders, Bridget moved past him, then on to the small kitchen where a bare lightbulb over the sink illuminated most of the room.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("A small pine table with matching chairs worn smooth from years of use was situated along the outside wall. As she moved toward it, she unbuttoned her coat. She was shrugging one shoulder free of the cream-colored ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("cashmere garment when he came up behind her and with both hands lifted it away for her.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you,” she murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("While she took a seat, he carried the coat over to a hall tree standing by a door that exited the house. After hanging it next to a jean jacket with a sheepskin collar, he moved to a white gas range and switched on a burner beneath a granite coffeepot.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The coffee was made for supper. It’s strong.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s fine,” she assured him. “I need for it to be strong.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With the burner blazing beneath the simple pot, he turned away from the stove and as his dark eyes focused on her, Bridget felt exposed and all too aware of how she must look to him. She’d not taken the time to change from the formal clothes she’d been wearing for Conall’s wedding reception. Now she desperately wished she’d taken a moment to race upstairs and change out of the strapless dress fashioned of emerald-green faille. To make matters worse, diamonds glittered at her throat, her ears and hair, while high, high heels of the same emerald color adorned her feet. No doubt he was viewing her as someone who lived far away from his world and she hated that this unexpected reunion was displaying her in a way that didn’t depict her normal day-to-day life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he failed to make any sort of comment, she felt compelled to explain. “I—was—when you called—it was at the wedding reception for my brother, Conall. I didn’t want to waste time changing clothes. That’s why—I’m dressed this way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry I interrupted your evening. I didn’t want to.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("He was still brutally honest, she decided. She figured ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("eating a sandwich of nails and sandpaper would have probably been easier than calling upon her for help. Not that he disliked her or even held ill feelings for her. No, the end of their relationship had been far more complex. There had been no hateful, judgmental words or spiteful arguing. They’d parted just as they had met, with love.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wasn’t complaining,” she told him. “Just explaining.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t need that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned back to the coffeepot while Bridget closed her eyes and tried to get her breathing back on an even keel. Of course he didn’t need explanations from her, she thought. What she was wearing or what she’d been doing didn’t concern him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Behind him, Johnny heard the coffee strike a boil and he turned his back to her in order to switch off the burner and gather cups from the cupboard. After he filled both of them with the dark, pungent liquid, he carried them over to the table where she sat, then went to the refrigerator to collect a can of evaporated milk.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he placed the milk can in front of her, a faint smile crossed her face. “Thank you for remembering,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Johnny could have told her that taking milk in her coffee was not the only thing he remembered about her. And seeing her again tonight was bringing those recollections back in a violent rush. Oh, God, he’d rather have taken a knife blade to his chest than call her tonight. But she was the only doctor his grandmother would agree to allow in the house. And with Naomi’s health rapidly deteriorating, he’d had no choice but to ask Bridget for help. Now as he looked at her, he felt sick with wants and regrets.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Somehow these past years he’d managed to avoid run")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("ning into her. It had meant declining invitations from her brother and his good buddy, Brady Donovan, to visit the Diamond D, and making sure he didn’t go near anywhere he suspected she might be. But that hadn’t taken much effort. His lifestyle rarely took him off the reservation and he’d never traveled in the same social circle as the well-to-do Donovans.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pulling out a chair across from her, he eased onto the seat. “What do I need to do for Grandmother?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She spilled a small amount of milk into her coffee and slowly stirred it with the spoon he’d left in her cup. “See that her room gets more heat and try to get as much liquid down her as possible. Things like chicken broth, fruit juices or even sports drinks. She hasn’t been consuming much food or drink, has she?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. Only a bit of goat’s milk. It was the only thing she wanted.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A soft sigh escaped her and Johnny’s gaze was drawn to her heart-shaped face. She was still breathtaking, he decided. Eyes as pure and green as a mountain meadow were framed by delicately arched brows and long lashes, both of which were a few shades darker than her copperred hair. Smooth, milk-white skin was sprinkled here and there with pale freckles, especially across the bridge of her straight little nose and the crest of her shoulders. Soft, dewy lips, the color of a raspberry, were full and tilted sweetly upward at the corners.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The lips, the freckles, the white satin skin of her body had all been touched by his mouth, he thought. But not enough. Not nearly enough.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s fine, too,” Bridget was saying. “Anything she’ll take to hydrate her and give her strength is good.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("She took another long sip of coffee, then spoke again. Though this time she kept her gaze on the liquid in her ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("cup rather than him. Johnny decided it was almost a relief not to feel her green eyes on his face.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She’ll need to take several more medications. Early in the morning, I’ll fetch them and drive back.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This jolted him. He’d only expected to see her just this once. Just long enough for her to diagnose his grandmother’s illness and prescribe medicine. He wasn’t sure he could take being around her any more than that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This isn’t about how you’re feeling, Johnny. This is about your ailing grandmother and what she needs.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Write the prescriptions and I’ll get them,” he told her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shook her head. “It would be a waste for you to make the trip when I’ve got to return anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why do you have to return?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her brows shot upward and he realized she considered his question stupid. And maybe it was. But having her here, seeing her so close was ripping him apart, like two hands tearing a piece of cloth. Much more of her presence and there would be nothing left to hold him together except a few fragile threads.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t think you understand the severity of your grandmother’s illness, Johnny. She needs an IV drip and that will have to be monitored. Plus, I’ll need to make sure her lungs haven’t worsened overnight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her voice had gone firm and professional and he was glad for that. The sound jerked him out of the past and away from the time when her soft words had excited him, soothed him, nestled in his heart like golden sunshine saved for a dark and lonely night.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He let out a heavy breath. “And what if they have worsened?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("She pressed fingertips to the tiny crease in the middle of her forehead. “My plan is to keep that from happen")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("ing. If it does… Then you or your grandfather will have to do your best to change her mind about the hospital.”")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His grandmother was a stubborn soul, Johnny thought. Though she loved her husband and grandson, she had her own ideas about life and how she should live it. If she believed the Great Spirit was calling, then she’d give up her earthly fight to survive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My grandparents have very little money. But whatever charges you need to make I’ll see that you’re paid in full.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Staring hard at him now, she lowered her cup to the tabletop. “I’m not here for money, Johnny,” she said stiffly. “Not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("any")]), _vm._v(" money.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t expect such favors from you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” she said softly, sadly. “You’ve never expected anything from me, have you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A tight fist was suddenly in his throat, twisting and clawing. He swallowed. “I’ve already taken enough from you, Bridget.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t say anything. Instead, she reached across the small tabletop and touched her hand to the top of his. Something hit him deep in the gut and for a moment the room around them faded. The urge to lift her hand to his lips, to pull her from the chair and gather her close was gripping him like an iron claw.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But having her body next to his wasn’t part of his plan. She was a luxury he couldn’t afford. A sin he couldn’t commit. Not again. She belonged in her own world. Not his. But he didn’t offend her by jerking his hand away. Instead, he endured the sweet torture until she finally cleared her throat and pulled her hand back to her side of the table.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("While he deliberately avoided making eye contact, she drained the last of her coffee and rose to her feet.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve done all I can do for right now,” she said. “But I’ll be back in a few hours with the medications she needs.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By the time she drove to Ruidoso there wouldn’t be much left of the night, he realized. Rising from the chair, he said, “You should rest first. And your clinic is—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Accustomed to dealing with my emergency leaves,” she interrupted, then added with a faint smile. “Don’t worry, Johnny, I’m a doctor. I’m used to going on very little sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was a doctor because she wanted to be. Not because she needed a job or the income. She was a giver. Not a taker. Yet she’d taken his heart and he’d never been able to get it back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nodding slightly, he said, “I’ll walk you to your Jeep.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That isn’t necessary.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The dogs don’t know you,” he explained.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Starting out of the kitchen, she said with a bit of humor, “By the time I get Naomi back on her feet, I’ll have the dogs eating out of my hand.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And what would she have him doing? Johnny wondered. Forgetting that he was a man of honor? Forgetting his vow to never touch her again? For his grandmother’s sake, he was going to have to push his emotions aside and deal with this woman in a reasonable way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But there was nothing reasonable about the way he was feeling as he walked along beside her. He wanted to jerk her into his arms and kiss her. He wanted to carry her off to some dark place and make love to her as though they’d never parted.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("Reasonable? Hell, it would be a miracle if he managed to resist her. But he had to, because letting her go the first time had nearly broken him. And he wasn’t ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("sure he’d survive it again…?. That’s why he couldn’t let himself take a second chance with Bridget. Giving her up twice would crush him.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  })]), _c('a', {
    attrs: {
      "id": "page22"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page22"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b28df82e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459212268_ch01.vue
// module id = 78
// module chunks = 0